// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_21-3";
export var dialog = "_21-0";
export var divClassnameSwatch = "_21-8";
export var flexSwatch = "_21-4";
export var header = "_21-1";
export var styleAttributeSwatch = "_21-7";
export var swatch = "_21-2";
export var textHeaderSwatch = "_21-5";
export var webSwatch = "_21-6";